import { useHistory } from 'react-router';
import { useClientWebRouteProps, usePathGenerator } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ReactAppRedirectError } from '@common/model/reactApp/error';
import { CatalogItemPageProps } from './../model';

export const useRedirectFromLegacyUrl = (props: CatalogItemPageProps) => {
  const { match } = props;
  const generatePath = usePathGenerator();
  const history = useHistory();
  const pageProps = useClientWebRouteProps<ClientWebPage.CatalogItem>();

  if (!match.params.id || !Number.isNaN(parseInt(match.params.id))) {
    return;
  }

  const idString = match.params.id.replace(/\D/g, '');

  if (!idString.length) {
    return;
  }

  const id = parseInt(idString);

  const redirectToUrl = generatePath({ page: ClientWebPage.CatalogItem, pageProps, pathParams: { id } });

  if (typeof window === 'undefined') {
    throw new ReactAppRedirectError(redirectToUrl);
  } else {
    history.replace(redirectToUrl);
  }
};
